import {ILanguageConfiguration} from "../interfaces/languageConfiguration.interface.ts";
import {IStepperStep} from "../interfaces/steperItem.interface.ts";

export const ONE_SECONDS_IN_ML = 1000
export const ONE_MINUTE_IN_ML = 60 * ONE_SECONDS_IN_ML


export const MAX_UPLOAD_FILE_SIZE_BYTES = 4 * 1024 ** 3

export type SUPPORTED_FILE_TYPES = "wmv" | "avi" | "mp4" | "mkv" | "mov"
export const ALLOWED_TYPES: Record<string, SUPPORTED_FILE_TYPES> = {
  "video/x-ms-wmv": "wmv",
  "video/x-msvideo": "avi",
  "video/mp4": "mp4",
  "video/x-matroska": "mkv",
  "video/quicktime": "mov",
};


export const CREATE_NEW_PROJECT_STEPS: IStepperStep[] = [
  {
    title: 'Upload Files',
    description: 'Upload and name each file'
  },
  {
    title: 'Subtitle',
    description: 'Select and configure subtitles'
  }
];

export const CREATE_NEW_PROJECT_SUBTITLE_STEPS: IStepperStep[] = [
  {
    title: 'Source Language',
    description: 'Select and configure source language'
  },
  {
    title: 'Target Languages',
    description: 'Select and configure target languages'
  }
];


export const LANGUAGE_DEFAULT_CONFIGURATION: ILanguageConfiguration = {
  maxCharactersPerLine: 40,
  minFramesGap: 2,
  maxSubtitleTime: 7,
  maxLines: 2,
  minSubtitleTimeInFrames: 20
}

export const LANGUAGE_CONFIGURATION_BOUNDS: Record<keyof ILanguageConfiguration, { min: number; max: number }> = {
  maxCharactersPerLine: {min: 10, max: 60},
  minFramesGap: {min: 1, max: 10},
  maxSubtitleTime: {min: 1, max: 12},
  maxLines: {min: 1, max: 4},
  minSubtitleTimeInFrames: {min: 1, max: 25},
};

export const GLIX_SHOT_DETECTION_SENSITIVITY_DEFAULT = 0.37

// Login footer legal links; both point at the marketing site until dedicated pages exist.
export const TERMS_OF_SERVICE_URL = "https://glix.ai";
export const PRIVACY_POLICY_URL = "https://glix.ai";
